import React, { Component } from 'react';
import { Card, Icon, message, Modal, Row, Tree } from 'antd';
import {
  queryDeleteMaterialDirectory,
  queryMaterialDirectoryInfo,
  querySaveMaterialDirectory,
} from '@api/administrative/material';
import ModalDirAdd from './ModalDirAdd';
import './TreeOrg.less';

const { TreeNode } = Tree;
const { confirm } = Modal;

class TreeOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      selectedKeys: [],
      expandedKeys: [],
      isAddType: true,
      directoryInfo: null,
    };
  }

  componentDidMount() {
    const list = this.props.data;
    const { directoryUuid } = this.props;
    this.setState({ list, selectedKeys: [directoryUuid] });
  }

  componentWillReceiveProps(nextProps) {
    const list = nextProps.data;
    const { directoryUuid } = nextProps;
    if (list !== this.props.data) {
      this.setState({
        list,
        expandedKeys: this.setAllExpandKeys(list),
        directoryInfo: null,
      });
    }

    if (directoryUuid !== this.props.directoryUuid) {
      this.setState({
        selectedKeys: [directoryUuid],
      });
    }
  }

  // 资料目录详情
  getDirectoryInfo = uuid => {
    queryMaterialDirectoryInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.directoryInfo = res.data;
        this.setState({
          directoryInfo: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 遍历展开所有节点（nice demand）
  setAllExpandKeys = list => {
    let expandedKeys = [];
    list.map(item => {
      if (item.children.length > 0) {
        expandedKeys.push(item.uuid);
        expandedKeys = expandedKeys.concat(this.setAllExpandKeys(item.children));
      }
      return item;
    });
    return expandedKeys;
  };

  onExpand = expandedKeys => {
    this.setState({
      expandedKeys,
    });
  };

  onSelect = (selectedKeys, e) => {
    this.setState({
      selectedKeys,
    });
    this.props.onSelect({
      uuid: e.selected ? e.node.props.dataRef.uuid : '',
      name: e.selected ? e.node.props.dataRef.name : '',
    });
  };

  onDrop = info => {
    const { database, databaseUuid } = this.props;
    const dropPos = info.node.props.pos.split('-');
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
    queryMaterialDirectoryInfo({ uuid: info.node.props.dataRef.uuid }).then(res => {
      if (res.statusCode === 200) {
        const directoryInfo = res.data;
        const params = {};
        params.uuid = info.dragNode.props.dataRef.uuid;
        params.name = info.dragNode.props.dataRef.name;
        params.database = database;
        params.databaseUuid = databaseUuid;
        if (dropPosition === -1) {
          params.parentUuid = directoryInfo.parentUuid;
        } else {
          params.parentUuid = directoryInfo.uuid;
        }
        this.directoryAddSubmit(params);
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  /** ------------------新增/编辑/删除资料目录-------------------------------------------*/
  // 弹窗开关
  hideModalDirAdd = flag => {
    this.setState({
      dirAddVisible: !!flag,
    });
  };

  addTopDirectory = e => {
    e.stopPropagation();
    this.setState({ isAddType: true }, () => {
      this.hideModalDirAdd(true);
    });
  };

  // 新增的弹窗
  addDirectory = (item, e) => {
    e.stopPropagation();
    this.getDirectoryInfo(item.uuid);
    this.setState({ isAddType: true }, () => {
      this.hideModalDirAdd(true);
    });
  };

  // 编辑的弹窗
  editDirectory = (item, e) => {
    e.stopPropagation();
    this.getDirectoryInfo(item.uuid);
    this.setState({ isAddType: false }, () => {
      this.hideModalDirAdd(true);
    });
  };

  // 新增/编辑提交
  directoryAddSubmit = params => {
    querySaveMaterialDirectory(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.getDirectoryList();
        this.hideModalDirAdd();
        this.setState({ directoryInfo: null });
      } else {
        message.error(res.message);
      }
    });
  };

  // 删除
  showDelDirectory = (item, e) => {
    e.stopPropagation();
    const _this = this;
    confirm({
      title: '确定删除该资料目录?',
      onOk() {
        _this.directoryDeleteSubmit(item);
      },
    });
  };

  directoryDeleteSubmit = item => {
    const { databaseUuid, database } = this.props;
    const params = {};
    item && (params.uuid = item.uuid);
    params.databaseUuid = databaseUuid;
    params.database = database;
    item &&
      queryDeleteMaterialDirectory(params).then(res => {
        if (res.statusCode === 200) {
          message.success(res.message);
          this.props.getDirectoryList();
          this.setState({ directoryInfo: null });
        } else {
          message.error(res.message);
        }
      });
  };
  /**-----------------------------------------------------------------------------*/

  titleItem = item => {
    return (
      <span className="treeTitle">
        {item.name}
        <span className="treeButton">
          <Icon
            type="edit"
            onClick={e => this.editDirectory(item, e)}
            style={{ paddingRight: '5px' }}
          />
          <Icon
            type="plus-circle"
            onClick={e => this.addDirectory(item, e)}
            style={{ paddingRight: '5px' }}
          />
          <Icon type="minus-circle" onClick={e => this.showDelDirectory(item, e)} />
        </span>
      </span>
    );
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={this.titleItem(item)} key={item.uuid} {...item} />;
    });
  };

  render() {
    const {
      list,
      isAddType,
      dirAddVisible,
      directoryInfo,
      selectedKeys,
      expandedKeys,
    } = this.state;
    const { database, databaseUuid } = this.props;
    return (
      <Card
        style={{ padding: '10px', height: '100%' }}
        bodyStyle={{ padding: '0', height: '100%' }}
      >
        <Row type="flex" justify="end">
          <Icon type="plus-circle" onClick={this.addTopDirectory} style={{ paddingRight: '5px' }} />
        </Row>
        <Tree
          showLine
          draggable
          onDrop={this.onDrop}
          onSelect={this.onSelect}
          selectedKeys={selectedKeys}
          onExpand={this.onExpand}
          expandedKeys={expandedKeys}
        >
          {this.renderTreeNodes(list || [])}
        </Tree>
        <ModalDirAdd
          visible={dirAddVisible}
          onOk={this.directoryAddSubmit}
          onCancel={() => this.hideModalDirAdd(false)}
          database={database}
          data={directoryInfo || {}}
          isAddType={isAddType}
          databaseUuid={databaseUuid}
        />
      </Card>
    );
  }
}

export default TreeOrg;



// WEBPACK FOOTER //
// ./src/components/administrative/material/TreeOrg.js